(function () {
  "use strict";

  const POINTS_PER_EURO = 2;

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }

  function parseMoneyToCents(input) {
    if (!input) return null;
    let s = String(input).trim().replace(/\s/g, "");
    s = s.replace(/[^0-9,.\-]/g, "");
    if (!s) return null;

    // "1.234,56" -> "1234.56"
    if (s.includes(",") && s.includes(".")) s = s.replace(/\./g, "").replace(",", ".");
    else if (s.includes(",")) s = s.replace(",", ".");

    const v = Number(s);
    if (!isFinite(v)) return null;
    return Math.round(v * 100);
  }

  function getRoot() {
    return qs("[data-ok-points-root]");
  }

  function getScope(rootEl) {
    return (
      rootEl.closest("product-information") ||
      rootEl.closest(".product-details-wrapper") ||
      document
    );
  }

  function getKachingBlock(scope) {
    return qs("kaching-bundles-block, .kaching-bundles__block", scope);
  }

  function getSelectedBar(scope) {
    return qs(".kaching-bundles__bar--selected", scope);
  }

  function getKachingQty(scope, selectedBar) {
    const kInp =
      (selectedBar && qs(".kaching-bundles__quantity-selector__input", selectedBar)) ||
      qs(".kaching-bundles__bar--selected .kaching-bundles__quantity-selector__input", scope);

    if (kInp && kInp.value != null) {
      const n = parseInt(String(kInp.value), 10);
      if (isFinite(n) && n > 0) return n;
    }

    const formQty = qs('form[action*="/cart/add"] input[name="quantity"]', scope);
    if (formQty && formQty.value != null) {
      const n = parseInt(String(formQty.value), 10);
      if (isFinite(n) && n > 0) return n;
    }

    return 1;
  }

  function getSelectedBarPriceCents(scope) {
    const el = qs(".kaching-bundles__bar--selected .kaching-bundles__bar-price", scope);
    return el ? parseMoneyToCents(el.textContent) : null;
  }

  function getNativeUnitPriceCents(scope) {
    const el =
      qs("#ProductPrice .money", scope) ||
      qs("[data-product-price] .money", scope) ||
      qs('[data-update-id="item-price"] .money', scope) ||
      qs(".price .money", scope);

    return el ? parseMoneyToCents(el.textContent) : null;
  }

  function getSelectedUpsellsTotalCents(selectedBar) {
    if (!selectedBar) return 0;

    const upsells = qsa(".kaching-bundles__upsell", selectedBar);
    if (!upsells.length) return 0;

    let total = 0;

    for (const u of upsells) {
      const checkbox = qs(".kaching-bundles__upsell__checkbox", u);
      const isSelected =
        checkbox?.classList.contains("kaching-bundles__upsell__checkbox--selected") ||
        checkbox?.getAttribute?.("aria-checked") === "true" ||
        u.classList.contains("is-selected") ||
        u.classList.contains("selected");

      if (!isSelected) continue;

      const priceEl = qs(".kaching-bundles__upsell__price", u);
      const fullEl  = qs(".kaching-bundles__upsell__full-price", u);

      const priceC = priceEl ? parseMoneyToCents(priceEl.textContent) : null;
      const fullC  = fullEl  ? parseMoneyToCents(fullEl.textContent)  : null;

      let chosen = null;
      if (priceC != null && fullC != null) chosen = Math.min(priceC, fullC);
      else chosen = (priceC != null) ? priceC : fullC;

      if (chosen != null && chosen > 0) total += chosen;
    }

    return total;
  }

  /* ---------- Abonnement (Firmhouse-blok) ---------- */

  // Geeft het abonnementsblok terug als de switch op "Abonnement" staat, anders null
  function getActiveAboBox(scope) {
    let host = null;
    if (scope && scope !== document && scope.closest) host = scope.closest('[data-fh-mode="abo"]');
    if (!host) host = qs('[data-fh-mode="abo"]', scope);
    if (!host) return null;
    return qs("[data-fh-abo]", host);
  }

  // Prijs van het gekozen plan x aantal, in centen (0 als er geen plan gekozen is)
  function getAboTotalCents(aboBox) {
    const input = qs(".fh-plans:not([hidden]) .fh-plan__input:checked", aboBox);
    const card = input ? input.closest("[data-fh-plan-card]") : null;
    if (!card) return 0;

    const unit = parseInt(card.getAttribute("data-price"), 10);
    if (!isFinite(unit) || unit <= 0) return 0;

    const qtyEl = qs("[data-fh-qty]", aboBox);
    let qty = qtyEl ? parseInt(String(qtyEl.value), 10) : 1;
    if (!isFinite(qty) || qty < 1) qty = 1;

    return unit * qty;
  }

  function isAboTarget(t) {
    return !!(t && t.closest && t.closest("[data-fh-abo]"));
  }

  /* ---------- Berekening ---------- */

  function showPoints(root, out, totalCents) {
    if (totalCents == null || totalCents <= 0) {
      out.textContent = "0";
      root.style.display = "none";
      return;
    }
    const points = Math.floor((totalCents * POINTS_PER_EURO) / 100);
    out.textContent = String(points);
    root.style.display = "block";
  }

  function updateAll() {
    const root = getRoot();
    if (!root) return;

    const out = qs("[data-ok-points-value]", root);
    if (!out) return;

    const scope = getScope(root);

    // 1) Abonnementsmodus: punten over plan-prijs x aantal
    const aboBox = getActiveAboBox(scope);
    if (aboBox) {
      showPoints(root, out, getAboTotalCents(aboBox));
      return;
    }

    // 2) Eenmalige aankoop: punten over de gekozen Kaching-bundel
    const kaching = getKachingBlock(scope);
    const hasKaching = !!kaching;
    const selectedBar = hasKaching ? getSelectedBar(scope) : null;

    const qty = hasKaching ? getKachingQty(scope, selectedBar) : 1;

    let totalCents = null;

    if (hasKaching) {
      const barCents = getSelectedBarPriceCents(scope);
      if (barCents != null) totalCents = barCents; // bundelprijs (basis)
    }

    if (totalCents == null) {
      const unit = getNativeUnitPriceCents(scope);
      if (unit != null) totalCents = unit * qty;
    }

    if (totalCents != null && hasKaching && selectedBar) {
      totalCents += getSelectedUpsellsTotalCents(selectedBar);
    }

    showPoints(root, out, totalCents);
  }

  function debounce(fn, wait) {
    let t = 0;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, wait);
    };
  }

  const schedule = debounce(updateAll, 60);

  function isKachingTarget(t) {
    if (!t || !t.closest) return false;
    return !!t.closest(
      ".kaching-bundles__bar, .kaching-bundles__bar-container, .kaching-bundles__bar-main, .kaching-bundles__bar-radio," +
      ".kaching-bundles__quantity-selector__button, .kaching-bundles__quantity-selector__input," +
      ".kaching-bundles__upsell, .kaching-bundles__upsell__checkbox, .kaching-bundles__upsell__text, .kaching-bundles__upsell__link"
    );
  }

  function bind() {
    const root = getRoot();
    if (!root) return;

    const scope = getScope(root);
    const kaching = getKachingBlock(scope);
    const aboBox = qs("[data-fh-abo]", scope);

    // 1) Event delegation (werkt ook als Kaching dynamisch re-rendert) + abonnementsblok
    document.addEventListener("click", function (e) {
      if (isKachingTarget(e.target) || isAboTarget(e.target)) schedule();
    }, { passive: true, capture: true });

    document.addEventListener("input", function (e) {
      if (isKachingTarget(e.target) || isAboTarget(e.target)) schedule();
    }, { passive: true, capture: true });

    document.addEventListener("change", function (e) {
      // variants / qty / kaching / abonnement
      if (isKachingTarget(e.target) || isAboTarget(e.target)) schedule();
      if (e.target && (e.target.name === "id" || e.target.name === "quantity")) schedule();
    }, { passive: true, capture: true });

    // 2) Observer op Kaching block (maar NIET de hele body)
    if (kaching) {
      try {
        const mo = new MutationObserver(schedule);
        mo.observe(kaching, {
          subtree: true,
          childList: true,
          characterData: true,
          attributes: true
        });
      } catch (e) {}
    }

    // 3) Observer op het abonnementsblok (plan, aantal, variant en switch)
    if (aboBox) {
      try {
        const moAbo = new MutationObserver(schedule);
        moAbo.observe(aboBox, {
          subtree: true,
          childList: true,
          characterData: true,
          attributes: true,
          attributeFilter: ["class", "hidden"]
        });
      } catch (e) {}
    }

    // 4) Extra: observer op selected bar (soms update Kaching alleen daar de prijs/tekst)
    function attachSelectedBarObserver() {
      const bar = getSelectedBar(scope);
      if (!bar) return;

      try {
        const moBar = new MutationObserver(schedule);
        moBar.observe(bar, {
          subtree: true,
          childList: true,
          characterData: true,
          attributes: true
        });
      } catch (e) {}
    }

    // attach nu + na korte delay (voor laat renderen)
    attachSelectedBarObserver();
    setTimeout(attachSelectedBarObserver, 400);
    setTimeout(attachSelectedBarObserver, 1200);
  }

  // Boot
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      bind();
      updateAll();
      setTimeout(updateAll, 300);
      setTimeout(updateAll, 900);
    });
  } else {
    bind();
    updateAll();
    setTimeout(updateAll, 300);
    setTimeout(updateAll, 900);
  }
})();